// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionArticleTallyEmbededCode_articleMain__rsh5G","noSidePaddings":"SectionArticleTallyEmbededCode_noSidePaddings__A-gRM"};